module.exports = __webpack_public_path__ + "static/media/icon-read-notification.6ca2dc93.svg";